let obj = {};
obj.companyIdTypeOptions = [
    {
        value: "1",
        name: "身份证",
    },
    {
        value: "03",
        name: "统一社会信用代码",
    }
]
obj.plansValues = [
    {
        name: '套餐一',
        value: 'P060306-T1',
        money1: '10万',
        money2: '1万',
    },
    {
        name: '套餐二',
        value: 'P060306-T2',
        money1: '30万',
        money2: '3万',
    }, {
        name: '套餐三',
        value: 'P060306-T3',
        money1: '50万',
        money2: '5万',
    }, {
        name: '套餐四',
        value: 'P060306-T4',
        money1: '60万',
        money2: '6万',
    }, {
        name: '套餐五',
        value: 'P060306-T5',
        money1: '80万',
        money2: '8万',
    }, {
        name: '套餐六',
        value: 'P060306-T6',
        money1: '100万',
        money2: '10万',
    }
]
//客户性质
obj.customerQuality = [
    { name: '法人', value: '01' }
]
//施工资质
obj.constructionNature = [
    { name: '特级', value: '3' },
    { name: '一级', value: '1' },
    { name: '二级', value: '2' },
    { name: '三级', value: '4' },
]
//施工类型
obj.constructionType = [
    { name: '室内装修工程（无室外）', value: '1' }
]
//关联投保人column
obj.columns = [
    { title: '序列号', dataIndex: 'idx', key: 'idx', align: 'center', scopedSlots: { customRender: 'idx' } },
    {
        title: '企业名称', dataIndex: 'companyName', key: 'companyName', align: 'center',
        scopedSlots: { customRender: 'companyName' }
    },
    {
        title: '操作', dataIndex: 'operation', key: 'operation', align: 'center',
        scopedSlots: { customRender: 'operation' }
    }
]

export default { ...obj }